import React from 'react';

const VARIANTS = {
  text: 'h-4 rounded',
  card: 'h-32 rounded-xl',
  chart: 'h-64 rounded-xl',
  circle: 'rounded-full',
};

const Skeleton = ({ className = '', variant = 'text' }) => (
  <div className={`skeleton-shimmer ${VARIANTS[variant] || VARIANTS.text} ${className}`} />
);

export default Skeleton;
